import { max } from 'lodash-es';
import Routes from '../routes.mjs';
import formatDateWithLocale from './formatDateWithLocale';
import getJobMediaUrl from './getJobMediaUrl';
import messages from './messages.json';

const dateFormatLocale = 'en-US';

const getJobJsonLdData = (job, locale, intl, origin) => {
  if (!job) return null;

  const {
    id,
    slug,
    title,
    active,
    publishedAt,
    expiresAt,
    updatedAt,
    publications,
    country,
    city,
    region,
    address,
    addressRegion,
    postalCode,
    company: {
      name: hiringOrganization,
      imageUrls,
      logoUrls,
    },
    teaser,
  } = job;

  const logoUrl = getJobMediaUrl(imageUrls, logoUrls, origin);

  const prefix = intl.formatMessage(messages.prefix) === 'fr' ? 'fr' : null;

  const jobUrl = Routes.findAndGetUrls(
    `job.${locale}`,
    prefix ? { prefix, slug, id } : { slug, id },
  ).urls.as;

  const datePosted = publishedAt
    || max(publications);

  const cityText = locale === 'en-US'
    ? [city, addressRegion, postalCode]
      .filter(Boolean)
      .join(', ')
    : city;

  const description = `${
    formatDateWithLocale(
      new Date(datePosted),
      dateFormatLocale,
      { year: 'numeric', month: 'long', day: 'numeric' },
    )
  } - ${title} ${cityText} - ${teaser}`;

  const validThrough = active && expiresAt
    ? formatDateWithLocale(expiresAt, dateFormatLocale)
    : formatDateWithLocale(updatedAt, dateFormatLocale);

  return JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'JobPosting',
    title,
    description,
    datePosted: formatDateWithLocale(datePosted, dateFormatLocale),
    validThrough,
    hiringOrganization: {
      '@type': 'Organization',
      name: hiringOrganization,
      ...(logoUrl && { logo: logoUrl }),
    },
    url: jobUrl,
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: city,
        addressRegion: region,
        streetAddress: address,
        addressCountry: country,
        postalCode,
      },
    },
  });
};

export default getJobJsonLdData;
